import React from 'react';
import { LocationPage } from './useLocationPage';
import './useLocationPage.css';

// ─── Images ───────────────────────────────────────────────────────────────────
// Swap out any of these for Sarasota-specific shots
import heroImg   from '../images/tampa3.webp';
import bgImg     from '../images/image8.webp';
import slideImg1 from '../images/image121.webp';
import slideImg2 from '../images/image117.webp';
import slideImg3 from '../images/image50.webp';

// ─── Config ───────────────────────────────────────────────────────────────────
const hydeParkConfig = {

  /* ── SEO ────────────────────────────────────────────────────────────────── */
  pageTitle:       'Hyde Park Tampa Tree Service | Sam\'s Tree Service',
  metaDescription: 'Expert tree trimming and removal in Hyde Park, Tampa FL. Sam\'s Tree Service handles dangerous trees safely and professionally.',
  canonicalUrl:    'https://samstreeservice.com/tree_service_hyde_park',

  /* ── Hero ───────────────────────────────────────────────────────────────── */
  heroHeading: 'Serving Hyde Park',
  heroImageUrl: heroImg,
  bgImageUrl:   bgImg,

  /* ── Slide images ───────────────────────────────────────────────────────── */
  slideImage1: slideImg1,
  slideImage2: slideImg2,
  slideImage3: slideImg3,

  /* ── Main text panel ────────────────────────────────────────────────────── */
  sectionHeading: 'Professional Tree Service in Hyde Park Specializing In Dangerous Trees',

  paragraphs: [
    `At <strong>Sam's Tree Service</strong>, we serve the premium properties and 
     tree lined streets of <strong>Hyde Park</strong> with expert tree care that 
     matches the standards of this distinguished Tampa neighborhood. Grand oaks 
     and mature palms are part of what makes Hyde Park beautiful but they also 
     require professional management to stay safe. Overhanging limbs near historic 
     homes, large canopies threatening parked vehicles and structures, and storm 
     damage that needs immediate attention are all in our wheelhouse.`,

    `We specialize in <strong>precision tree removal and trimming on high value 
     residential and mixed use properties</strong> careful canopy reductions 
     that preserve aesthetics while eliminating hazards, tight lot removals near 
     historic structures, storm response, and large limb work that requires 
     skilled rigging and execution. We protect your property inside and out.`,

    `<strong>Sam's Tree Service</strong> delivers reliable, professional tree care 
     throughout <strong>Hyde Park</strong> and the surrounding 
     <strong>South Tampa</strong> waterfront corridor keeping premier properties 
     safe, beautiful, and storm ready.`,
  ],
  ctaLabel: 'Get a Free Estimate!',

  /* ── Service buttons (optional — defaults to the 4 standard ones) ────────── */
  // serviceButtons: [
  //   { label: 'Tree Trimming', to: '/tree_trimming' },
  //   { label: 'Tree Removal',  to: '/tree_removal'  },
  //   { label: 'Stump Removal', to: '/stump_removal'  },
  //   { label: 'Debris Hauling',to: '/debris_hauling' },
  // ],

  /* ── Google Map ─────────────────────────────────────────────────────────── */
  mapCity: 'Hyde Park, FL',
};

// ─── Page ─────────────────────────────────────────────────────────────────────
const Services_HydePark = () => <LocationPage config={hydeParkConfig} />;
export default Services_HydePark;
